export default __webpack_public_path__ + "static/media/payments-hero.jpg";